<script>
const generateTempKey = () => `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

const emptyFaq = () => ({
  id: null,
  tempKey: generateTempKey(),
  question: '',
  answer: ''
})

export default {
  name: 'FaqList',
  components: {
    Action: () => import('@/components/general/Action'),
    Icon: () => import('@/components/general/Icon'),
    InputField: () => import('@/components/general/InputField'),
    TextareaField: () => import('@/components/general/TextareaField')
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },

    validation: {
      type: Object,
      default: () => ({})
    },

    maxQuestion: {
      type: Number,
      default: 500
    },

    maxAnswer: {
      type: Number,
      default: 5000
    }
  },

  methods: {
    fieldValidation (index, field) {
      const each = this.validation && this.validation.$each

      return each ? each[index][field] : {}
    },

    add () {
      this.$emit('input', [
        ...this.items,
        emptyFaq()
      ])
    },

    remove (index) {
      const next = this.items.slice()

      next.splice(index, 1)
      this.$emit('input', next)
    },

    patchItem (index, patch) {
      const next = this.items.map((item, i) => (i === index
        ? {
          ...item,
          ...patch
        }
        : item))

      this.$emit('input', next)
    }
  }
}
</script>

<template>
  <div>
    <div
      v-for="(faq, index) in items"
      :key="faq.id || faq.tempKey || index"
      class="article-faq-item"
    >
      <div class="article-faq-item-header">
        <span class="article-faq-item-number">
          {{ $t('articles.form:faq.item', { number: index + 1 }) }}
        </span>
        <button
          type="button"
          class="article-faq-item-remove"
          :aria-label="$t('articles.form:faq.remove')"
          @click="remove(index)"
        >
          <Icon name="delete" />
        </button>
      </div>

      <InputField
        :label="$t('articles.form:faq.question')"
        :value="faq.question"
        :validation="fieldValidation(index, 'question')"
        :counter="maxQuestion"
        @input="(value) => patchItem(index, { question: value })"
      />

      <TextareaField
        :label="$t('articles.form:faq.answer')"
        :value="faq.answer"
        :validation="fieldValidation(index, 'answer')"
        :counter="maxAnswer"
        :auto-grow="true"
        @input="(value) => patchItem(index, { answer: value })"
      />
    </div>

    <Action
      type="button"
      flat
      icon="add"
      :text="$t('articles.form:faq.add')"
      @click="add"
    />
  </div>
</template>
